import { AdType, } from '../player/types';
import { PlaybackError } from '../errors';
import { ErrorCode } from '../errors/enums/error-code';
import { generatePsid } from '../player/utils';
import { EventKey as TelemetryEventKey } from '../telemetry/enums/event-key';
import { assetTypeToTelemetryAssetType } from '../telemetry/utils';
import { SeekController } from '../gt12/seek-controller';
import { AdEventKey } from '../player/enums';
import { getDeviceCapabilities } from '../capability';
export const PlayerWithPlay = (Base) => {
    return class extends Base {
        async playUrl(asset, playOptions) {
            this._assetType = playOptions.assetInfo.assetType;
            this._playOptions = playOptions;
            const capabilities = await getDeviceCapabilities();
            const assetTypeSupported = capabilities.streamTypeInformation.find((streamTypeInfo) => {
                return streamTypeInfo.type === asset.streamType;
            });
            if (!assetTypeSupported) {
                throw new PlaybackError(ErrorCode.NotSupported, `Stream type ${asset.streamType} is not supported on this device`);
            }
            const sessionAbortController = this.startNewSession();
            let psid = this.psid ?? generatePsid();
            const triggerSkipAdbreakEvent = (type) => {
                this.triggerEvent({
                    type,
                    psid,
                });
            };
            if (playOptions.gt12ChannelInfo) {
                this.seekController = new SeekController(playOptions.gt12ChannelInfo, playOptions.adsInfo ?? null, triggerSkipAdbreakEvent.bind(this));
            }
            else {
                this.seekController = null;
            }
            if (!playOptions.isInternalCall) {
                await this.stop();
                psid = generatePsid();
                this.psid = psid;
                this.triggerTelemetryNewSessionEvent(psid, assetTypeToTelemetryAssetType(playOptions.assetInfo.assetType), 'external', asset.streamType);
            }
            if (sessionAbortController.signal.aborted) {
                throw new PlaybackError(ErrorCode.SessionAbort, 'Session start aborted by new Session');
            }
            const adapterRequest = {
                playOptions,
                asset,
            };
            this.triggerTelemetryEvent({
                type: TelemetryEventKey.STREAM_LOADING,
                psid,
            });
            const adapterMedia = await this.adapter.load(adapterRequest);
            if (sessionAbortController.signal.aborted) {
                throw new PlaybackError(ErrorCode.SessionAbort, 'Session start aborted by new Session');
            }
            if (playOptions.autoplay) {
                this._isPausedByUser = false;
            }
            await this.dispatchMedia(adapterMedia, playOptions.isInternalCall);
            if (adapterRequest.playOptions.gt12ChannelInfo?.schedule) {
                const cuePoints = adapterRequest.playOptions.gt12ChannelInfo?.schedule
                    .flatMap((schedule) => schedule.markers)
                    .map((marker) => {
                    return {
                        start: marker.start,
                        end: marker.end,
                    };
                });
                this.triggerEvent({
                    type: AdEventKey.AD_METADATA,
                    data: {
                        adType: AdType.FAST_FORWARD,
                        cuePoints,
                    },
                });
            }
        }
    };
};
